// @ts-nocheck
import markerSDK from "@marker.io/browser";
import useAccount from "classes/Accounts/hooks/useAccount";
import useToken from "classes/Accounts/hooks/useToken";
import { t } from "i18next";
import React, { useState } from "react";
import "./MarkerIoButton.css";

export default function MarkerIoButton() {
	const [Widget, setWidget] = useState(false);
	const { token } = useToken();
	const { account } = useAccount();
	const initied = React.useRef(false);

	const initWidget = async () => {
		// Marker.io's CDN is often blocked by ad blockers (Brave Shields, uBlock, etc.).
		// Swallow the failure so it doesn't surface as an unhandled promise rejection.
		try {
			const widget = await markerSDK.loadWidget({
				project: "68877fc8e30eb1400c0e22fd",
			});

			if (account.employeeId && token) {
				widget.setReporter({
					email: account.mail || account.login,
					fullName: account.lastName + " " + account.firstName,
				});
				widget.setCustomData({
					EmployeeId: account.employeeId,
					CompanyId: account.companyId,
					SiteId: account.siteId,
					Role: account.role,
					AspNetUserId: account.aspNetUserId,
					UserTemplateId: account.userTemplateId,
					FirstConnexion: account.firstConnexion,
					LastConnexion: account.lastConnexion,
					Token_Regeneration: account.tokenRegeneration,
					ByPass_Moderation: account.bypassModeration,
					IsVisibleInApp: account.isActive,
					WorkFamilyId: account.workFamilyId,
					WorkFunctionId: account.workFunctionId,
					ClientVersion: import.meta.env.VITE_VERSION,
				});
			}
			widget.hide();
			widget.on("show", () => {
				widget.hide();
			});
			setWidget(widget);
		} catch {
			// Widget unavailable — button stays hidden.
		}
	};

	React.useEffect(() => {
		if (!initied?.current) initWidget();
		initied.current = true;
	}, []);

	if (!Widget) return false;
	return (
		<div className="markerio-io-btn" onClick={() => Widget?.capture()}>
			{t("Commons.REPORT_BTN")}
		</div>
	);
}
